const ValidationError = require('./errors/ValidationError');
const success = require('./success');
const moment = require('@transfeeradev/moment');
const { DateService, TransferPixService } = require('@transfeeradev/api-services');
const { errors, transferPaymentMethod } = require('@transfeeradev/api-enums');

class PaymentDate {
  constructor(data) {
    this._transfer = Object.assign({}, data.transfer);
  }

  validate() {
    if (!this._transfer.payment_date) {
      return success;
    }
    const isPix = this._isPixPayment();
    const dataValidation = this._dateFormatValidation();

    if (!dataValidation.isValid) {
      return dataValidation;
    }

    const beforeCurrentDateValidation = this.beforeCurrentDate();
    if (!beforeCurrentDateValidation.isValid) {
      return beforeCurrentDateValidation;
    }

    if (!isPix) {
      const hourValidation = this.validateTime();

      if (!hourValidation.isValid) {
        return hourValidation;
      }
    }

    const maxDate = this._maxDate();
    if (!maxDate.isValid) {
      return maxDate;
    }

    if (!isPix) {
      const businessDayValidation = this._businessDay();
      if (!businessDayValidation.isValid) {
        return businessDayValidation;
      }
    }

    return success;
  }

  validateTime() {
    if (this._isPixPayment()) {
      return success;
    }

    const TED_HOUR_LIMIT = '16:30:00';
    return this._isHourValid(TED_HOUR_LIMIT, errors.ptBr.tra.INVALID_TED_PROCESSING_HOUR);
  }

  beforeCurrentDate() {
    if (moment(this._transfer.payment_date).isBefore(moment(), 'day')) {
      return new ValidationError(errors.ptBr.tra.PAYMENT_DATE_BEFORE_CURRENT_DATE);
    }

    return success;
  }

  _isHourValid(endHour, error) {
    const SAME_HOUR_OR_BETWEEN_SYMBOL = '[]';
    const paymentDate = moment(this._transfer.payment_date || moment());
    const today = moment();

    if (paymentDate.isSame(today, 'day')) {
      const start = moment('00:00:00', 'HH:mm:ss');
      const end = moment(endHour, 'HH:mm:ss');

      if (!moment().isBetween(start, end, null, SAME_HOUR_OR_BETWEEN_SYMBOL)) {
        return new ValidationError(error);
      }
    }

    return success;
  }

  _maxDate() {
    const paymentDate = moment(this._transfer.payment_date);
    const thirtyDays = moment().add(30, 'days');

    if (paymentDate.isAfter(thirtyDays, 'day')) {
      return new ValidationError(errors.ptBr.tra.MAX_PAYMENT_DATE);
    }

    return success;
  }

  _businessDay() {
    if (!moment(this._transfer.payment_date).isBusinessDay()) {
      return new ValidationError(errors.ptBr.tra.BUSINESS_DAY);
    }

    return success;
  }

  _dateFormatValidation() {
    this._transfer.payment_date = DateService.getFormatted(this._transfer.payment_date);

    if (!this._transfer.payment_date) {
      return new ValidationError(errors.ptBr.tra.PAYMENT_DATE_WRONG_DATE_FORMAT);
    }

    return success;
  }

  _getDBA() {
    return (
      this._transfer.destinationBankAccount ||
      this._transfer.destination_bank_account ||
      this._transfer.DestinationBankAccount
    );
  }

  _isPixPayment() {
    return (
      TransferPixService.isPix(this._getDBA()) ||
      this._transfer.emv ||
      this._transfer.payment_method === transferPaymentMethod.PIX
    );
  }
}

module.exports = PaymentDate;
